import { differenceInCalendarWeeks } from 'date-fns';

// DST-safe week number within a rotation cycle (1-based)
export const getRotationWeekNumber = (date, rotationStartDate, totalWeeks) => {
  if (!rotationStartDate || !totalWeeks || totalWeeks < 1) return 1;
  const weeksDiff = differenceInCalendarWeeks(date, rotationStartDate, { weekStartsOn: 0 });
  return (((weeksDiff % totalWeeks) + totalWeeks) % totalWeeks) + 1;
};

const hasMenuData = (slot) => {
  if (!slot) return false;
  if (typeof slot === 'string') return slot.trim() !== '';
  if (typeof slot === 'object') {
    return Object.values(slot).some((v) => typeof v === 'string' && v.trim() !== '');
  }
  return false;
};

// Returns the day's menu object for the computed week; if that week's entry
// is missing or completely empty, falls back to the first week that has data.
export const getDaySchedule = (schedule, weekKey, dayName) => {
  if (!schedule) return {};
  const slot = schedule[weekKey]?.[dayName];
  if (hasMenuData(slot)) return slot;
  for (const wk of Object.keys(schedule).sort()) {
    const s = schedule[wk]?.[dayName];
    if (hasMenuData(s)) return s;
  }
  return slot && typeof slot === 'object' ? slot : {};
};

// Same fallback for custom rotations where values are recipe name strings
export const getCustomDayRecipe = (schedule, weekKey, dayName) => {
  if (!schedule) return null;
  const val = schedule[weekKey]?.[dayName];
  if (typeof val === 'string' && val.trim()) return val;
  for (const wk of Object.keys(schedule).sort()) {
    const v = schedule[wk]?.[dayName];
    if (typeof v === 'string' && v.trim()) return v;
  }
  return null;
};
